import { Form, Formik } from "formik";
import Select from "react-select";
import { getInspectionReportDefaultFilters } from "./store/inspectionReportStoreUtils";

const buttonStyles = {
  search: {
    backgroundColor: "var(--btn-primary-bg)",
    color: "var(--btn-primary-text)",
    border: "none",
    fontWeight: 600,
    padding: "8px 24px",
    borderRadius: "6px",
    fontSize: "14px",
  },
  reset: {
    backgroundColor: "#FDE8E8",
    color: "#8B1A1A",
    border: "none",
    fontWeight: 600,
    padding: "8px 24px",
    borderRadius: "6px",
    fontSize: "14px",
  },
};

const defaultFilterValues = getInspectionReportDefaultFilters();

const InspectionReportFilter = ({
  initialValues = defaultFilterValues,
  wardOptions = [],
  onSearch,
  onReset,
}) => (
  <Formik
    initialValues={initialValues}
    enableReinitialize
    onSubmit={(values) => onSearch?.(values)}
  >
    {({ values, setFieldValue, resetForm, handleSubmit }) => (
      <Form onSubmit={handleSubmit}>
        <div className="row align-items-end">
          <div className="col-md-3 mb-3">
            <label className="form-label">Ward</label>
            <Select
              inputId="wardId"
              name="wardId"
              classNamePrefix="react-select"
              options={wardOptions.map((ward) => ({
                value: String(ward.wardId ?? ward.circleId ?? ""),
                label: ward.wardNo ?? ward.circleName ?? ward.wardName,
              }))}
              value={
                wardOptions
                  .map((ward) => ({
                    value: String(ward.wardId ?? ward.circleId ?? ""),
                    label: ward.wardNo ?? ward.circleName ?? ward.wardName,
                  }))
                  .find((option) => option.value === String(values.wardId)) ||
                null
              }
              onChange={(selected) =>
                setFieldValue("wardId", selected ? selected.value : "")
              }
              placeholder="Select Ward"
              isClearable
              menuPlacement="auto"
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">From Date</label>
            <input
              type="date"
              name="fromDate"
              value={values.fromDate}
              onChange={(event) => setFieldValue("fromDate", event.target.value)}
              className="form-control bg-white"
            />
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">To Date</label>
            <input
              type="date"
              name="toDate"
              value={values.toDate}
              onChange={(event) => setFieldValue("toDate", event.target.value)}
              className="form-control bg-white"
            />
          </div>

          <div className="col-md-3 mb-3 d-flex gap-2">
            <button type="submit" style={buttonStyles.search}>
              APPLY FILTERS
            </button>
            <button
              type="button"
              style={buttonStyles.reset}
              onClick={() => {
                resetForm({ values: getInspectionReportDefaultFilters() });
                onReset?.();
              }}
            >
              RESET
            </button>
          </div>
        </div>
      </Form>
    )}
  </Formik>
);

export default InspectionReportFilter;
